import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
// Film mode only (see scripts/build-film-mobile-css.js): puts the mobile
// layout back inside the phone frame, where desktop media queries still fire.
import './film-mobile.generated.css';
import { isFilmMode } from './portals/demo/demoMode';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './services/firebaseAnalytics';

if (Capacitor.getPlatform() === 'android') {
  document.documentElement.classList.add('platform-android');
}
// TODO: Enable App Check when reCAPTCHA site key is ready
// import { initAppCheck } from './services/firebaseAppCheck';
// initAppCheck();

// Initialize Firebase Analytics
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Auto-update service worker — silently applies new version on next open.
//
// NOT on the film channel. Two reasons, both fatal to a recording:
//   1. `controllerchange` reloads the page the moment a new build takes over,
//      so a redeploy throws whoever is filming back to the Welcome screen
//      mid-take.
//   2. Until that happens the worker serves the PREVIOUS bundle from cache,
//      so a fix that is already deployed looks like it was never made.
// Any worker registered by an earlier visit is torn down and its caches
// dropped, so the channel always serves exactly what was last published.
if (isFilmMode()) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .catch(() => {});
  }
  if ('caches' in window) {
    caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))).catch(() => {});
  }
} else if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').then(registration => {
      // Poll for updates every time the app loads
      registration.update();
    }).catch(() => {});

    // When the new SW takes control, reload once — completely transparent to the user
    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}

reportWebVitals();
